/*******************************************************************************
 * 共通
 ******************************************************************************/
/**
 * 質問回数設定有無
 */
export const QustionType = {
  /** 制限あり */
  Limited: '1',
  /** 制限なし */
  UnLimited: '2'
} as const;
export type QustionType = typeof QustionType[keyof typeof QustionType];

/*******************************************************************************
 * インターフェース
 ******************************************************************************/
/**
 * 入札情報取得レスポンス
 */
export interface GetTenderResponse {
  /** 取引 ID */
  dealId: string;
  /** 入札 ID */
  tenderId: string;
  /** タイトル */
  title: string;
  /** 
   * 金額
   * NOTE: 依頼者が設定した金額
   */
  amount?: number;
  /** 
   * 受注金額
   * NOTE: 受注者が設定した受注金額
   */
  desiredAmount?: number;
  /** 質問回数設定有無 */
  questionType: string;
  /** 
   * 質問回数
   * NOTE: 質問回数設定有無が「2: 無制限」の場合は null
   */
  questionLimit: number | null;
  /** コメント */
  comment?: string;
}

/**
 * 入札状況取得レスポンス
 */
export interface GetTenderSituationResponse {
/**
 * 入札者ユーザー ID
 * 
 * NOTE: 作成者の場合：通常表示
 *       受注者の場合：末尾2文字を除き*で伏字
 */
  tenderUserId: string;
  /**
   * 入札者アイコン URL
   * 
   * NOTE: 作成者の場合のみ設定
   */
  tenderIconUrl: string | null;
  /** 入札日時 */
  tenderAt: Date;
  /** 受注希望金額 */
  amount: number;
  /** 質問回数設定有無 */
  questionType: QustionType;
  /** 
   * 質問回数
   * NOTE: 質問回数設定有無が「2: 無制限」の場合は null
   */
  questionLimit: number | null;
  /** コメント */
  comment?: string;
}

/**
 * 入札情報登録リクエスト
 */
export interface CreateTenderRequest {
  /** 取引 ID */
  dealId: string;
  /** 金額 */
  amount?: number;
  /** 質問回数設定有無 */
  questionType: string;
  /** 
   * 質問回数
   * NOTE: 質問回数設定有無が「2: 無制限」の場合は null
   */
  questionLimit: number;
  /** コメント */
  comment?: string;
}

/**
 * 入札情報登録レスポンス
 */
export interface CreateTenderResponse {
  /** 入札 ID */
  tenderId: string; 
}